import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISubmit, SubmitResponse } from '@interfaces';
import {
  MultiSignerGetResponseHydrated_Gift,
  MultiSignerGetResponseHydrated_IT,
  MultiSignerPostPayload,
  MXMPatchResponse,
} from '@interfaces/models/multi-signer-approval';
import { InternalTransferPayload } from '@interfaces/submit/internal-transfer-co0-payload.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { Observable } from 'rxjs';

import { FMFResponse } from '../fraud-micro-frontend/fmf.service';

@Injectable({
  providedIn: 'root',
})
export class MultiSignerApprovalService {
  readonly endpoint = 'secure/multi-signer';
  constructor(private http: HttpClient) {}

  getTransfer(
    transferId: string,
    poid: string,
  ): Observable<MultiSignerGetResponseHydrated_IT | MultiSignerGetResponseHydrated_Gift> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.get<MultiSignerGetResponseHydrated_IT | MultiSignerGetResponseHydrated_Gift>(
      `${this.endpoint}?transferId=${transferId}`,
      {
        headers,
      },
    );
  }

  sendTransfer(
    mxmRequestData: MultiSignerPostPayload,
    poid: string,
  ): Observable<{ message: string }> {
    const headers = new HttpHeaders().set('poid', poid);
    return this.http.post<{ message: string }>(this.endpoint, mxmRequestData, { headers });
  }

  addOwnerConsentForMXM(
    transferId: string,
    filenetPayload: ISubmit | InternalTransferPayload[],
  ): Observable<MXMPatchResponse> {
    return this.http.post<MXMPatchResponse>(`${this.endpoint}/consent`, {
      transferId,
      filenet: filenetPayload,
    });
  }

  finalizeTransfer(
    mockRecaptchaLevel: RecaptchaMockResult,
    fmfResponse: FMFResponse,
    submitData: ISubmit | InternalTransferPayload[],
    transferId: string,
  ): Observable<SubmitResponse> {
    // Multi-IT: the payload is an array of CO0 transfer payloads wrapped under `payload`.
    // Each element must carry fmf/recaptcha/fraud per the backend schema
    // (mockRecaptchaLevel required, mockFraudDetectorLevel required-but-nullable), mirroring
    // submitMultiTransactionsEndpoint. Fraud simulation isn't wired into the finalize path,
    // so mockFraudDetectorLevel is sent as null to satisfy validation.
    const body = Array.isArray(submitData)
      ? {
          payload: submitData.map((data) => ({
            ...data,
            fmfResponse,
            mockRecaptchaLevel,
            mockFraudDetectorLevel: null,
          })),
          transferId,
        }
      : { ...submitData, fmfResponse, mockRecaptchaLevel, transferId };
    return this.http.post<SubmitResponse>(`${this.endpoint}/submit`, body);
  }
}
